import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useToast } from "../../components/hooks/use-toast";
import useProject from "../../components/hooks/useProject";
import useHazard from "../../components/hooks/useHazard";

import HazardEditorTabs from "./HazardEditorTabs";
import HazardEditorBreadcrumbs from "./HazardEditorBreadcrumbs";

import { MIL882EMatrix, getMatrix } from "../../helpers/riskHelper";

const HazardEditor = () => {
  const { projectId, hazardId } = useParams();
  const { project } = useProject(projectId);
  const { hazard, setHazard } = useHazard(projectId, hazardId);

  const [riskMatrix, setRiskMatrix] = useState(null);

  const { toast } = useToast();

  useEffect(() => {
    const loadRiskMatrix = async () => {
      if (project && project.riskMatrix) {
        try {
          const riskMatrix = await getMatrix(project.riskMatrix);

          if (!riskMatrix) {
            console.warn(
              `Risk matrix ${project.riskMatrix} not found, using default`
            );

            // Optionally set a default matrix
            setRiskMatrix(MIL882EMatrix);
            return;
          }

          setRiskMatrix(riskMatrix);
        } catch (error) {
          console.error("Error loading risk matrix:", error);

          toast({
            variant: "destructive",
            title: "Error loading risk matrix",
            description:
              "Failed to load risk matrix. Using default matrix instead.",
          });

          // Fallback to default matrix
          setRiskMatrix(MIL882EMatrix);
        }
      }
    };

    loadRiskMatrix();
  }, [project, toast]);

  return (
    <>
      {/* New hazard */}
      {project && riskMatrix && !hazardId && hazard && (
        <HazardEditorBreadcrumbs
          project={project}
          riskMatrix={riskMatrix}
          hazard={hazard}
          setHazard={setHazard}
        />
      )}

      {/* Existing hazard */}
      {project && riskMatrix && hazardId && hazard && (
        <HazardEditorTabs
          project={project}
          riskMatrix={riskMatrix}
          hazard={hazard}
          setHazard={setHazard}
        />
      )}
    </>
  );
};

export default HazardEditor;
